import BlankGift from '@components/blank/BlankGift';
import SubCategory from '@components/SubCategory';
import { useAtom } from 'jotai';

import { giftCategoryIdAtom } from '../../atoms/giftItemAtoms';
import useGiftCategories from '../../hooks/useGiftCategories';

function Categories() {
    const categories = useGiftCategories();
    const [giftCategoryId, setGiftCategoryId] = useAtom(giftCategoryIdAtom);
    if (categories?.length === 0) {
        return (
            <BlankGift type='APPLY' />
        );
    }
    return (
        <SubCategory.Container value={giftCategoryId}
            setValue={setGiftCategoryId}>
            {categories?.map((c) => (
                <SubCategory value={c.id}
                    key={c.id}>
                    {c.name}
                </SubCategory>
            ))}
        </SubCategory.Container>
    );
}

export default Categories;
